/*
 * @Author: your name
 * @Date: 2022-02-26 13:44:11
 * @LastEditTime: 2024-02-02 11:14:54
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \kares_pad\src\i18n\language\zh-CN.js
 */
import zh from './yh_zh'

export default {
  // 主页
  home: {
    describe1: '欢迎使用',
    describe2: '让世界只有指尖的距离',
    describe3: '拥有完美的跨平台解决方案，其基于网络平台，采用分布式区域管理技术，可以有效整合各种多媒体资源，实现远程制作，发布和管理节目。'
  },
  app: {
    more: '查看更多',
    PersonalCenter: '个人中心',  //PersonalCenter
    HelpDocument: '帮助文档',  //HelpDocument
    LogOut: '退出登录',  //LogOut
    AddMaterial: '新增素材',  //AddMaterial
    CreateProgram: '新建节目',  //CreateProgram
    CreateRelease: '新建发布',  //CreateRelease
    AddTerminal: '添加终端',  //AddTerminal
    CreateAccount: '新建账号',  //CreateAccount
    Percent: '下载进度',  // Percent
    TerminalName: '终端名称',  // Terminal name
    ReleaseSchedule: '发布进度', // Release schedule
    status: '状态',  // Status
    operate: '操作',  // Operate
    retransmission: '重传',  // Retransmission
    Cancel: '取消',  // Cancel
    CancelAll: '取消全部',  // Cancel all
    AllRetransmission: '重传全部',  // All retransmission
    ClearanceToComplete: '清除完成',  // Clearance to complete
    RemoveAll: '清除全部',  // Remove all
  },
  // 基础组件
  basics: {
    ...zh.basics,
    materialCatalogue: '素材目录',
    structureGrouping: '组织结构分组',
    inStreamType: '插播类型'
  },
  public: {
    search: '请输入查询关键字',
  },
  // 页面路由
  router: {
    // 帮助
    help: '帮助',
    // 素材管理
    material: '素材管理',
    // 节目管理
    programme: '节目管理',
    editProgramme: '节目编辑',
    publishProgramme: '高级发布',
    // 终端管理
    terminal: '终端管理',
    // 审核管理
    check: '审核管理',
    checkMaterial: '素材审核',
    checkProgramme: '节目审核',
    checkPublish: '发布审核',
    // 日志管理
    log: '日志管理',
    logLogin: '登录日志',
    logOperation: '操作日志',
    logTerminal: '终端日志',
    // 高级管理
    seniorManagement: '高级管理',
    organization: '组织结构',
    userManage: '用户管理',
    RoleManage: '角色管理',
    systemLayout: '系统设置',
    nodeManage: '节点管理',
    reviewSet: '审核设置',
    softwareLicence: '软件授权',
  },
  device: {

  },
  explorer: {
    clickUpload: '将文件拖到此处，或<em>点击上传</em>',
    sizeLimit: '单文件不超过',
    video: '视频',
    picture: '图片',
    uploadFiles: '上传文件',
    newFolder: '新建文件夹',
    deleteFiles: '删除文件',
    materialAll: '已加载全部素材',
    materialsLoaded: '点击加载更多素材',
    move: '移动',
    copy: '复制',
    delete: '删除',
    all: '全选',
    name: '名称',
    resolution: '分辨率',
    fileSize: '文件大小',
    creationTime: '创建时间',
    operate: '操作',
    FolderName: '文件夹名', // Folder name
    deleteFile: '请问是否删除当前选中文件?', // IF delete currently selected file?
    BackEdit: '返回节目编辑', // Back to program edit
    FileMove: '文件移动',  // File Move
    FileCopy: '文件复制',  // File Copy
    StartAll: '全部开始', // Start all
    StopAll: '全部停止',  // Stop all
    EmptyFinish: '清空完成', // Empty finish
    CancelAll: '取消全部',  // Cancel all
    NoFiles: '暂无上传文件', // No uploaded files yet
    Status: '状态', // Status
    Check: '查看', // Check
    Stop: '停止', // Stop
    Start: '开始', // Start
    Cancel: '取消', // Cancel
    finish: '完成', // finish
  },
  log: {
    export: '导出',
    selectDevice: '选择设备',
    deviceSn: '设备SN',
    operateTime: '操作时间',
    operateUser: '操作用户',
    function: '功能',
    describe: '描述',
    dateArr: '日期范围',
    startDate: '开始日期',
    endDate: '结束日期',
    search: '查询',
    searchTips: '请选择一台设备查询',
    loadingTips: '日志获取中，请稍后',
    no: '编号',
    content: '内容',
    operateObj: '操作对象',
    operateContent: '操作信息',
    selectTips1: '仅支持查询三个月内的数据',
    searchTips1: '请先选择一台终端，确定时间范围，并进行查询',
    exportTips: '仅可导出查询时间范围内的数据'
  },
  login: {
    Login: '登 录', //Login
    memberRegister: '立即注册', //MemberRegister
    ForgetThePassword: '忘记密码？', //Forget the password
    NoLogin: '七天内免登录', //No login for seven days
    verification: '请输入验证码', //Please enter the verification code
    account: '请输入账户', //Please enter your account
    password: '请输入密码', //Please enter password
    helpDocument: '帮助文档' // help document
  },
  manage: {

  },
  review: {
    ...zh.review,
    review: '审核',
    enterKey: '请输入关键字',
    screenshot: '截图',
    name: '名称',
    group: '机构',
    createTime: '提交时间',
    publisher: '发布者',
    operate: '操作',
    check: '查看',
    pass: '已通过',
    reject: '拒绝',
    materialCheck: '素材审核',
    pleaseInputContent: '请输入审核内容',
    approve: '通过审核',
    rejectReview: '拒绝审核',
    releaseReview: '发布审核',
    resonForReject: '请输入拒绝原因',
    all: '全部',
    waitReview: '待审核',
    approves: '通过',
    selectTips: '请至少选择一条素材',
    selectTips1: '未选择发布单号',
    deleteTips: '确认全部删除?',
    singleNo: '单号',
    loop: '循环',
    timming: '定时',
    instream: '插播',
    noAdap: '不自适应',
    adap: '自适应屏幕大小'
  },
  schedule: {
    ...zh.schedule,
    loop: '循环播放',
    timpingPlay: '定时播放',
    emerPlay: '紧急插播',
    releaseRecord: '发布记录',
    releaseMan: '发布管理',
    playNo: '发布单号',
    group: '机构',
    releaseType: '发布类型',
    releaseNow: '立即发布',
    releaseTim: '发布时间',
    publisher: '发布人',
    review: '审核',
    pedReview: '待审核',
    noReview: '无审核',
    noPass: '不通过',
    pass: '已通过',
    waitRelease: '待发布',
    expird: '已失效',
    operate: '操作',
    detail: '详情',
    delete: '删除',
    deletePlay: '删除节目',
    deletePlayTip: '请问是否要永久删除当前选中节目？',
    keyWords: '请输入关键词',
    noSelectTip: '未选择任何发布记录',
    addPlay: '添加节目',
    selectProgram: '选择节目单',
    delPro: '删除节目',
    delProTip: '请问是否要清空所有节目？',
    screenshot: '截图',
    proName: '节目单名称',
    structure: '组织结构',
    resolution: '分辨率',
    createTime: '创建时间',
    noProgram: '当前没有节目',
    moveDown: "不能再下移",
    moveUp: '不能再上移动',
    tips: '提示',
    playList: '播放列表',
    terminalList: '终端列表',
    releaseProp: '发布属性',
    offline: '离线',
    timimgPlan: '定时发布',
    user: '用户',
    terminalName: '终端名称',
    terminalState: '设备状态',
    publishSate: '发布状态',
    planModole: '播放模式',
    playStrategy: '发布策略',
    playPlan: '播放计划',
    playCount: '播放次数',
    playsCount: '连续播放次数',
    pleaseSelect: '请选择',
    playTimes: '播放时长',
    conPlayTime: '连续播放时间',
    publish: '发布',
    customize: '自定义',
    once: '1',
    twice: '2',
    treeTimes: '3',
    fourTimes: '4',
    fiveTimes: '5',
    sixTimes: '6',
    sevenTimes: '7',
    eightTimes: '8',
    nineTimes: '9',
    tenTimes: '10',
    countTips: '次数最少为1',
    pubSuccessTip: '发布成功',
    selectTip1: '请至少选择两个节目',
    planPre: '节目预览',
    addPlayStep: '添加计划步骤',
    selectDate: '选择日期时间',
    instreamResver: '预约插播',
    instreamNow: '立即插播',
    selectTimeTips: '选择的时间不能小于当前时间',
    palyTime: '播放时间',
    selectStartTime: '选择开始时间',
    selectEndTime: '选择结束时间',
    conserLoop: '连续循环次数',
    validDate: '有效日期',
    date: '日期',
    daily: '每日',
    startTimeTips: '开始时间不能晚于结束时间',
    endTimeTips: '结束时间不能早于开始时间',
    startDateTips: '开始日期不能晚于结束日期',
    endDateTips: '结束日期不能早于开始日期',
    saveAplan: '至少保留一个计划',
    check: '查看',
    planSize: '节目尺寸',
    planName: '发布名称',
    leastTime: '失效日期',
    NewProgramInfor: '新增节目信息' //New Program Infor
  },
  system: {
    ...zh.system,
    clearTips1: '是否清空当前所有审核人员?',
    clearTips2: '是否清空当前审核人员?',
    selectReviewer: '选择审核人员',
    noReviers: '无相关审核权限的人员',
    createTips: '请先创建审核账号',
    sameReviwers: '下一机构共用同一审核人员',
    email: '邮箱',
    lastLogin: '上次登录',
    resetPwd: '重置密码',
    subUser: '下属用户',
    NumOfTerminals: '终端数量',
    NumOfPro: '节目数量',
    editPwd: '修改密码',
    oriPwd: '原始密码',
    newPwd: '新设密码',
    confirmPws: '确定密码',
    modifyInfo: '修改信息',
    changeNick: '修改昵称',
    changeEmail: '修改邮箱',
    personalCenter: '个人中心',
    enterOriPwd: '请输入原始密码',
    enterNewPwd: '请输入新设密码',
    confirmPwd: '请确定密码',
    enterNick: '请输入昵称',
    pwdNoPass: '两次密码不一致',
    changePwdSucc: '修改密码成功',
    modiSuccess: '修改成功',
    modiFail: "修改失败",
    noSet: '未设置',
    PleaseInputEmail: '请输入邮箱' // Please enter the Email
  },
  terminal: {
    treeTitle: '组织结构分组',
    Details: '详情',
    online: '在线',
    offline: '离线',
    list: '列表',
    card: '图表',
    map: '地图',
    keyWord: '请输入关键字',
    refresh: '刷新',
    add: '添加',
    delete: '删除',
    deviceName: '设备名称',
    remark: '备注',
    resolution: '分辨率',
    types: '类型',
    version: '版本号',
    status: '状态',
    operate: '操作',
    edit: '修改',
    loading: '拼命加载中',
    allSelect: '跨页全选',
    selected: '已选',
    selectAll: '本页全选',
    selectInMap: '请在地图上选择设备所在地',
    structure: '组织结构',
    selectGroup: '请选择组织结构',
    selectSize: '请选择分辨率',
    customize: '自定义',
    selectSn: '请选择SN',
    deviceTip: '设备名称不能为空',
    snTip: 'SN不能为空',
    sizeTip: '屏幕分辨率不能为空',
    deviceType: '设备类型',
    cancel: '取消',
    confirm: '确定',
    delDevice: '删除终端',
    delDevTip: '请问是否要永久删除所选终端？',
    onlineTotal: '在线统计',
    reboot: '重启',
    offscreen: '关屏',
    onscreen: '开屏',
    timeTask: '定时指令',
    conBright: '亮度调节',
    conVoice: '声音调节',
    relay: '继电器开关',
    timeZone: '时区校准',
    signalChange: '信号切换',
    synScreen: '多屏同步',
    timePlay: '定时播放开关',
    timeOn: '定时开关机',
    wTip: '分辨率W为空',
    hTip: '分辨率H为空',
    xTip: '位置X为空',
    yTip: '位置Y为空',
    mapTip: '请缩小地图检查表格信息!!!',
    selectTip: '未选择任何设备',
    deviceDetail: '设备详情',
    playList: '播放列表',
    affi: '所属机构:',
    screenType: '屏幕类型：',
    boxTime: '盒子时钟',
    noData: '暂无数据',
    currTimeZone: '当前时区',
    deviceLan: '设备语言',
    deviceZoom: '内存空间',
    runState: '运行状态',
    runTime: '连续运行',
    lastHeart: '最近心跳',
    timeOrder: '定时指令',
    comAddr: '服务器地址',
    voice: '声音',
    birght: '亮度',
    no: '序号',
    proName: '节目名称',
    power: '继电器',
    milRefresh: '秒自动刷新',
    viewPho: '查看原图',
    setTimeZone: '设置时区',
    terminalUp: '终端升级',
    upType: '升级方式',
    cloudUp: '云端升级',
    localUp: '本地文件升级',
    clickUp: '点击上传',
    name: '名称',
    type: '型号',
    verInfo: '版本信息',
    schedule: '进度',
    noUp: '无需升级',
    waitStar: '等待开始',
    downExc: '下载异常',
    downOK: '下载成功',
    checkError: '校验失败',
    upTip: '正在升级,完成将自动重启',
    erroBack: '异常反馈',
    downError: '下载失败',
    dowNum: '已选1台',
    upTips1: '注意：为防止数据丢失，请注意备份数据，升级完成设备自动重启，升级过程中，',
    upTips2: '请不要断电',
    upGr: '升级',
    serverAddEdit: '服务器地址修改',
    serEdTit: '将该终端迁移至新服务器',
    newAddr: '新服务器地址',
    test: '测试',
    user: '账号',
    psw: '密码',
    remove: '迁移',
    conRes: '确认重启',
    conOnSc: '确认开屏',
    upTips3: '请使用zip或apk文件',
    testOk: '测试通过',
    testFail: '测试失败',
    inputTips1: '请填写用户名和密码',
    opOk: '操作成功',
    mapTip1: '请在地图上标注设备位置',
    addDetail: '详情地址',
    lng: '经度',
    lat: '纬度',
    matTip2: '获取地址失败,请稍后尝试',
    orderTip: '确定重启所选终端?',
    orderTip1: '确定关闭所选终端屏幕?',
    orderTip2: '确定开启所选终端屏幕?',
    scSetting: '排程设置',
    selectTip1: '请选择',
    selectTip2: '新增定时指令',
    selectTip3: '请选择模板操作数据',
    conOrder: '操作指令',
    action1: '节目切换',
    action2: '亮度调节',
    action3: '音量调节',
    action4: '关屏',
    action5: '开屏',
    action6: '信号源切换',
    action7: '继电器关',
    action8: '继电器开',
    action9: '关闭屏幕',
    action10: '开启屏幕',
    value: '值',
    acVa1: 'HDMI优先',
    acVa2: '异步信号',
    acVa3: '同步信号',
    excTime: '执行时间',
    dateOk: '有效日期',
    noLimit: '无限制',
    isWeekLi: '有效星期',
    oper: '操作',
    newTem: '创建模板',
    savTem: '保存模板',
    addTem: '添加排程模板',
    temName: '模板名称',
    temTip1: '请输入模板名称',
    relayOn: '继电器开关',
    timeZoneSe: '时区选择',
    hdmiSi: 'HDMI信号源',
    inSin: '内部信号源',
    openMulti: '启用多屏同步播放',
    gps: 'GPS同步',
    localW: '网络同步',
    closeScreen: '关闭多屏同步播放',
    openTimePlay: '开启定时播放',
    closeTimePlay: '关闭定时播放',
    openTime: '开启定时',
    onTime: '开机时间',
    offTime: '关机时间',
    excDate: '执行日期',
    closeTime: '关闭定时',
    onlyG: '仅支持广告机设备',
    Sunday: '周日',
    Monday: '周一',
    Tuesday: '周二',
    Wednesday: '周三',
    Thursday: '周四',
    Friday: '周五',
    Saturday: '周六',
    noDeviceSelected: '未选择任何设备',
    group: '组织结构',
    onlineNum: '在线数量',
    offlineNum: '离线数量',
    totalNum: '设备总数',
    noOrderExc: '暂未执行任何命令',
    createTime: '创建时间',
    orderName: '命令名称',
    aimDevice: '目标设备',
    orderStatus: '命令状态',
    timeOut: '超时反馈',
    excSuccess: '执行成功',
    sent: '已发送',
    timeOpenNo: '定时开关：暂无数据',
    timeOpen: '定时开关：开',
    deviceOff: '设备离线',
    timeOpenTip: '定时播放已开启',
    timeCloseTip: '定时播放已关闭',
    programList: '节目列表',
    playTime: '节目时长',
    loop: '循环播放',
    excSta: '执行标准',
    timingPlay: '定时播放',
    playCount: '播放次数',
    proDelete: '删除节目',
    proDeleteTip: '确定删除节目?',
    timePlayOpenTip: '定时播放开启成功',
    timePlayCloseTip: '定时播放关闭成功',
    programChangeTip: '节目切换成功',
    programIsPlaying: '节目正在播放',
    powerList: '板载电源',
    allOpen: '全开',
    allClose: '全关',
    open: '开',
    close: '关',
    mulCard: '多功能卡',
    firstChannel: '第一路',
    secondChannel: '第二路',
    thirdChannel: '第三路',
    fourthChannel: '第四路',
    fifthChannel: '第五路',
    sixthChannel: '第六路',
    seventhChannel: '第七路',
    eighthChannel: '第八路',
    syncToTerminal: '同步至终端',
    allOpenTip: '确认开启/关闭多功能卡?',
    operComman: '操作指令',
    brigValue: '音量',
    method: '方式',
    speDate: '指定日期',
    speWeek: '指定星期',
    isDateLimit: '是否日期限制',
    isWeekLimit: '是否星期限制',
    edits: '编辑',
    timingOn: '定时指令已开启',
    timingOff: '定时指令已关闭',
    addTimingCom: '添加定时指令',
    ban: '禁用',
    opend: '开',
    closed: '关',
    timePlayTips: '定时播放中，无法切换',
    addDevice: '添加设备',
    deviceTypeTip: '请选择设备类型',
    key: '密匙',
    groupTips: '组织结构不能为空',
    least: '还剩',
    arrangeTip: '请选择0-100之间',
    saveSuccess: '保存成功',
    tempExit: '模板已存在,请更改名称',
    command: '命令',
    isSent: '已发送至',
    execSuccess: '执行成功',
    sented: '已发送',
    execFail: '超时反馈',
    runStatus: '在线&开屏&在播',
    timeLimit: '请间隔',
    timeLimitTip: '秒,再进行操作,还剩',
    seconds: '秒',
    syncPlay: '同步播放',
    signalStatus: '信号源状态',
    automatic: '自动',
    zh: '简体中文',
    en: '英语',
    vn: '越南语',
    isopend: '已开启',
    isclosed: '未开启',
    syncGps: 'GPS同步',
    syncNet: '网络同步',
    snTipLan: "请输入大写字母和数字",
    batchAdd: "批量添加",
    batchUpdate: "批量升级",
    live: "实时流",
    camera: "摄像头",
    CurrentStreamAddress: "当前流地址：",
    setParameters: "参数设置：",
    tips2: "当前流地址：",
    tips1: "获取播放实时画面：",
    buttonCopy: "复制",
    Resolution: "分辨率：",
    FrameRate: "帧率：",
    CentralControl: "中控控制",
    EditInstruction: "编辑指令",
    AddInstruction: "添加指令"
  },
  PE: {
    ...zh.programEditing
  }
}
